import React, { useContext } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { APIContext } from "../context";
import SuccessView from "../components/views/success";

export const AlertDialog = ({ open, title, text }) => {
  const { dialogAlertContent, dialogAlertOpen, setDialogAlertOpen } =
    useContext(APIContext);
  const handleClose = () => {
    setDialogAlertOpen(false);
  };
  return (
    <Dialog
      open={dialogAlertOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"sm"}
    >
      <DialogTitle id="alert-dialog-title" color="primary">
        {dialogAlertContent.titulo}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" color="secondary">
          {dialogAlertContent.mensaje}
        </DialogContentText>
        {dialogAlertContent.imagen === "smarthphone_voltear" && (
          <>
            <Typography variant="body1" fontWeight={400}>
              Si estás en un celular, ponlo en sentido horizontal
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const SuccessDialog = () => {
  const { dialogSuccessOpen, setDialogSuccessOpen } = useContext(APIContext);
  const handleClose = () => {
    setDialogSuccessOpen(false);
  };
  return (
    <Dialog
      open={dialogSuccessOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"sm"}
    >
      <DialogContent>
        <SuccessView />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
